import Fab, { type FabProps } from '@mui/material/Fab';
import Tooltip, { type TooltipProps } from '@mui/material/Tooltip';
import useId from '@mui/utils/useId';
import * as React from 'react';

interface IFabProps {
    Icon: React.ReactElement;
    TooltipProps: Omit<TooltipProps, 'children'>;
    FabProps?: FabProps;
}

const MuiFab: React.FC<IFabProps> = ({ Icon, TooltipProps, FabProps }) => {
    const tooltipId = useId();
    const fabId = useId();
    return (
        <React.Fragment>
            <Tooltip id={fabId} {...TooltipProps}>
                <Fab id={tooltipId} {...FabProps}>
                    {Icon}
                </Fab>
            </Tooltip>
        </React.Fragment>
    );
};

export default MuiFab;
